module.exports = __webpack_public_path__ + "static/force-vehicle-trails-vid-e16372926c974620703236525a423d46.mp4";